import ErrorBag from "@/helpers/ErrorBag";

let clearTimeoutId = null;

export const state = {
    errorBag: new ErrorBag()
};

export const getters = {
    has(state, field) {
        return state.errorBag.has(field);
    },
    get(state, field, index = 0) {
        return state.errorBag.get(field, index);
    },
    any(state) {
        return state.errorBag.any();
    },
    keys(state) {
        return state.errorBag.keys();
    },
};

export const mutations = {
    RECORD(state, errors) {
        // Clear any previously set timeout
        if (clearTimeoutId) {
            clearTimeout(clearTimeoutId);
        }

        // Set a new timeout to clear the errors after 15 seconds
        clearTimeoutId = setTimeout(() => {
            state.errorBag.clearAll();
        }, 15000); // 15000ms = 15 seconds
        return state.errorBag.record(errors);
    },
    CLEAR_FIELD(state, field) {
        return state.errorBag.clear(field);
    },
    CLEAR(state) {
        return state.errorBag.clearAll();
    },
};

export const actions = {

};
